module.exports = __webpack_public_path__ + "static/media/note-7.b7baa4db.jpg";